import React, { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import BankGradeCard from "./BankGradeCard";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: `What is ${import.meta.env.VITE_COMPANY_NAME}?`,
    answer: `${import.meta.env.VITE_COMPANY_NAME} is an online platform offering quick and hassle-free personal loans to salaried individuals. As part of ${import.meta.env.VITE_COMPANY_NBFC} (An RBI registered NBFC), we aim to provide accessible financial solutions for emergencies, home improvement, or celebrations.`,
  },
  {
    question: "Who is eligible for a personal loan?",
    answer: `To be eligible for a personal loan, you must be: 
• A salaried individual 
• Aged between 21 and 60 years 
• Employed with a recognized organization for at least 6 months 
• Earning a minimum monthly salary as per our criteria.`,
  },
  {
    question: "What documents are required?",
    answer: `You will need to submit the following documents: 
• Proof of identity (Aadhaar, PAN card, passport, etc.) 
• Proof of address (utility bills, Aadhaar, etc.) 
• Salary slips for the last three months 
• Bank statements for the last six months.`,
  },
  {
    question: "How much can I borrow?",
    answer: `${import.meta.env.VITE_COMPANY_NAME} offers personal loans ranging from ₹5,000 to ₹1,00,000 depending on your salary, repayment capacity, and credit score.`,
  },
  {
    question: "What is the interest rate?",
    answer: `The interest rate varies based on your credit profile, loan amount, and tenure. Typically, our rates are competitive and designed to be affordable for salaried individuals. Contact us to get a personalized quote.`,
  },
  {
    question: "How long does it take to get a loan?",
    answer: `Once you submit your application and documents, our team processes your request quickly. Loan approval usually takes a few minutes, and funds are disbursed within 5 minutes upon approval.`,
  },
  {
    question: "Can I repay my loan early?",
    answer: `Yes, ${import.meta.env.VITE_COMPANY_NAME} allows early repayment of loans. Please review your loan agreement or contact us for details.`,
  },
  {
    question: "How is my eligibility assessed?",
    answer: `We assess your loan eligibility based on factors such as your monthly income, credit score, job stability, and repayment history. A good credit score increases your chances of getting approved with a favorable interest rate.`,
  },
  {
    question: "Can I apply with a low credit score?",
    answer: `Yes, you can still apply for a loan with a low credit score. However, the approval decision and interest rate may vary based on your overall financial profile and ability to repay the loan.`,
  },
  {
    question: "What are the repayment options?",
    answer: `You can repay your loan through various payment options such as NACH (National Automated Clearing House), direct debit, or online payments via our website.`,
  },
  {
    question: "Is my data secure?",
    answer: `Absolutely. ${import.meta.env.VITE_COMPANY_NAME} uses advanced security measures, including encryption and secure servers, to ensure your personal and financial data is protected. We adhere to all data privacy regulations and take confidentiality seriously.`,
  },
  {
    question: "Can I track my loan application?",
    answer: `Yes, you can easily track the status of your loan application through our website by logging into your account. You will also receive updates via email and SMS at each stage of the process.`,
  },
  {
    question: "How can I contact customer support?",
    answer: `You can reach our customer support team through our website's contact form, by email at ${import.meta.env.VITE_COMPANY_EMAIL}.com, or by calling our helpline during business hours. We're here to assist you with any questions or concerns.`,
  },
];

const FAQ: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleIndex = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="min-w-screen bg-[#141237] text-white py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <Navbar />
        <h2 className="text-4xl font-bold mb-12 mt-10 text-center text-[#FF2D55] drop-shadow-lg">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="bg-gradient-to-r from-[#1F1B36] via-[#2B254D] to-[#1F1B36] rounded-xl shadow-2xl overflow-hidden border border-white hover:border-[#FF2D55] transition-all duration-300"
            >
              <p
                className="w-full flex justify-between items-center p-6 text-left  rounded-2xl hover:bg-[#FF2D55]/20 transition-colors focus:outline-none focus:ring-0"
                onClick={() => toggleIndex(idx)}
              >
                <span className="font-semibold text-lg">{item.question}</span>
                <span className="text-2xl">
                  {activeIndex === idx ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              </p>

              <div
                className={`px-6  transition-all duration-500 ease-in-out ${
                  activeIndex === idx
                    ? "max-h-96 opacity-100 mt-2"
                    : "max-h-0 opacity-0 overflow-hidden"
                }`}
              >
                <p className="text-gray-200 whitespace-pre-line">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16">
          <BankGradeCard />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default FAQ;
